import React from "react";
import App, { Container } from "next/app";

/* Styles */
import "bootstrap/dist/css/bootstrap.min.css";
import '../styles/main.scss';

export default class MyApp extends App {
  componentDidMount() {
    // Fonts();
  }

  render() {
    const { Component } = this.props;

    return (
      <Container>
        <Component />
      </Container>
    );
  }
}
